import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div style={{ padding: "2rem" }}>
      <h2>404 - Page Not Found</h2>
      <p>Sorry, we couldn't find that page.</p>
      <p>
        <Link to="/admin">Go back to the Portal</Link>
      </p>
    </div>
  );
}
